import type { ReactNode } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import ImpersonationBanner from './ImpersonationBanner';
import ScrollToTopButton from './ScrollToTopButton';
import MerchantMobilePortalReturn from '../merchant/MerchantMobilePortalReturn';
import { shouldShowMerchantMobileReturn } from '../../utils/accessPolicy';
import './Layout.css';

type LayoutProps = {
  children?: ReactNode;
};

const outerLayoutMobileReturnPaths = new Set([
  '/merchant/onboarding',
  '/merchant/events',
  '/merchant/external-payments',
]);

function Layout({ children }: LayoutProps) {
  const { policy } = useAuth();
  const location = useLocation();
  const content = children ?? <Outlet />;

  const showAdmin = policy?.workspace === 'admin';
  const showHeader = false;
  const showMerchantMobileReturn =
    outerLayoutMobileReturnPaths.has(location.pathname) &&
    shouldShowMerchantMobileReturn(policy?.raw ?? null, location.pathname);

  return (
    <div className="layout">
      <ImpersonationBanner />
      {showMerchantMobileReturn ? <MerchantMobilePortalReturn /> : null}
      {showHeader ? (
        <header className="layout__header">
          <nav className="layout__nav">
            <Link to="/guest">Guest</Link>
            <Link to="/merchant">Merchant</Link>
            {showAdmin ? (
              <>
                <Link to="/admin">Admin</Link>
                <Link to="/admin/schedule-planner">Schedule</Link>
              </>
            ) : null}
          </nav>
        </header>
      ) : null}
      <main className="layout__main">{content}</main>
      <ScrollToTopButton />
    </div>
  );
}

export default Layout;
